export enum ToastType {
  error = "error",
  success = "success",
  warning = "warning",
  notification = "notification",
}
